import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const slides = [
  "https://ranaurahub.com/palchina/slide1.png",
  "https://ranaurahub.com/palchina/slide2.png",
  "https://ranaurahub.com/palchina/slide3.png",
  "https://ranaurahub.com/palchina/slide4.png",
];

const HeroSlider = () => {
  const [index, setIndex] = useState(0);
  const go = (step: number) => setIndex((current) => (current + step + slides.length) % slides.length);

  useEffect(() => {
    const timer = window.setInterval(() => go(1), 4500);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className="relative h-[340px] md:h-[480px] lg:h-[650px] overflow-hidden bg-black" aria-label="عارض صور PalChina">
      {/* @section: hero-slider */}
      {slides.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`صورة رئيسية لجمعية الصداقة الفلسطينية الصينية ${i + 1}`}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${i === index ? "opacity-100" : "opacity-0"}`}
          loading={i === 0 ? "eager" : "lazy"}
        />
      ))}
      {/* أزرار التنقل يمين/يسار */}
      <button onClick={() => go(-1)} className="absolute left-4 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/80 p-3 text-black shadow-lg hover:bg-gold transition-colors" aria-label="الصورة السابقة"><ChevronLeft /></button>
      <button onClick={() => go(1)} className="absolute right-4 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/80 p-3 text-black shadow-lg hover:bg-gold transition-colors" aria-label="الصورة التالية"><ChevronRight /></button>
      {/* نقاط المؤشر */}
      <div className="absolute bottom-5 left-1/2 z-20 flex -translate-x-1/2 gap-2">
        {slides.map((_, i) => <button key={i} onClick={() => setIndex(i)} className={`h-3 rounded-full transition-all ${i === index ? "w-10 bg-gold" : "w-3 bg-white/70"}`} aria-label={`انتقل إلى الشريحة ${i + 1}`} />)}
      </div>
    </section>
  );
};

export default HeroSlider;
